import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import AgTechNoRecordsPage from '@agtech/web/components/Pages/Error/AgTechNoRecordsPage';
import { AgTechMoneyFormatter } from '@agtech/web/utilities/AgTechUtilities';
import _ from 'lodash';
import React from 'react'
import InvoiceGrid from '../components/grids/InvoiceGrid';
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';
import { useInvoiceDataGetUnpaidInvoicesQuery } from '@sales/data/invoicing/InvoicingDataQueries';
import AddPaymentDialog from '../dialogs/payments/InvoiceAddPaymentDialog';

const SaleInvoicingUnpaidInvoicesPage = () => {
    let getProcessedSalesQuery = useInvoiceDataGetUnpaidInvoicesQuery();

    return (
        <AgTechQueryLoadingSurface query={getProcessedSalesQuery}>
            {(unpaidInvoices) => unpaidInvoices.length > 0
                ? (
                    <div className='stretched column-based container'>
                        <div id='sale-invoicing-unpaid-grid' className='tall flexed column-based pr-3 container'>
                            <InvoiceGrid
                                title='Unpaid Invoices'
                                invoices={unpaidInvoices}
                                modifyGridProps={(gridProps) => ({
                                    ...gridProps,
                                    columns: [
                                        ...gridProps.columns,
                                        {
                                            header: 'Pay',
                                            value: invoice => (
                                                <AddPaymentDialog.Button
                                                    invoiceId={invoice.id}
                                                    classes='button-link'
                                                />
                                            ),
                                            showHeader: false,
                                            width: '140px'
                                        }
                                    ]
                                })}
                            />
                        </div>
                        <div className='tall row-based pl-3 vertical-pane w-[240px] flex'>
                            <div id='sale-invoicing-unpaid-count-metric'>
                                <AgTechMetric
                                    header='Processed Invoices'
                                    value={unpaidInvoices.length.toString()}
                                />
                            </div>
                            <div id='sale-invoicing-unpaid-total-metric'>
                                <AgTechMetric
                                    header='Total Invoiced'
                                    value={AgTechMoneyFormatter.format(_.sum(unpaidInvoices.map(invoice => invoice.invoiceTotal)))}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <AgTechNoRecordsPage
                        message="There are no unpaid invoices in the system right now."
                        secondaryMessage="Invoicing can be performed beneath the 'Unprocessed Sales' tab."
                    />
                )}
        </AgTechQueryLoadingSurface>
    )
}

export default SaleInvoicingUnpaidInvoicesPage
